import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=667f877a&scoped=true&"
import script from "./CheckboxList.vue?vue&type=script&lang=js&"
export * from "./CheckboxList.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxList.vue?vue&type=style&index=0&id=667f877a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f877a",
  null
  
)

export default component.exports